var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeverityIconsHigh24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6006 16.6327L14.6236 4.36085C14.0503 3.40959 13.0592 2.83398 11.9947 2.83398C10.9302 2.83398 9.93915 3.40959 9.36581 4.36085L2.38879 16.6327C1.88716 17.5196 1.86982 18.6229 2.34331 19.527C2.89089 20.545 3.91266 21.1716 5.01768 21.1671H18.9717C20.0692 21.1796 21.0892 20.5687 21.6461 19.5656C22.1338 18.6516 22.1164 17.5292 21.6006 16.6327Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6006 16.6327L14.6236 4.36085C14.0503 3.40959 13.0592 2.83398 11.9947 2.83398C10.9302 2.83398 9.93915 3.40959 9.36581 4.36085L2.38879 16.6327C1.88716 17.5196 1.86982 18.6229 2.34331 19.527C2.89089 20.545 3.91266 21.1716 5.01768 21.1671H18.9717C20.0692 21.1796 21.0892 20.5687 21.6461 19.5656C22.1338 18.6516 22.1164 17.5292 21.6006 16.6327ZM11.9947 17.3081C11.4923 17.3081 11.0851 16.8761 11.0851 16.3433C11.0851 15.8105 11.4923 15.3785 11.9947 15.3785C12.4971 15.3785 12.9044 15.8105 12.9044 16.3433C12.9044 16.8761 12.4971 17.3081 11.9947 17.3081ZM11.9947 14.4137C12.4971 14.4137 12.9044 13.9818 12.9044 13.449V9.5899C12.9044 9.05707 12.4971 8.62513 11.9947 8.62513C11.4923 8.62513 11.0851 9.05707 11.0851 9.5899V13.449C11.0851 13.9818 11.4923 14.4137 11.9947 14.4137Z",
    fill: "#F00707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverityIconsHigh24);
export default __webpack_public_path__ + "static/media/severity-icons-high-24.897ef9ac6d4fc221fe1eb75d11c9b658.svg";
export { ForwardRef as ReactComponent };